

var _squid = require('squid');

var _fi = require('xo-models/src/fi');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoFiLogos', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?'
        },
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                cardTypes: _fi.$CardTypesModel.instance($scope.token + ':' + _squid.$locale.country, {
                    token: $scope.token,
                    country: _squid.$locale.country
                })
            });
        }]
    };
});

_squid.$locale;

_squid.$populate;

_fi.$CardTypesModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/fi-logos/directive.js
// module id = ../node_modules/xo-wallet-components/src/fi-logos/directive.js
// module chunks = 0